const settingsConfig = {
  layout: {
    style: 'simple',
    config: {},
  },
};

export default settingsConfig;
